import { render, staticRenderFns } from "./ModalConfirmarManutencao.vue?vue&type=template&id=3b203331&scoped=true&"
import script from "./ModalConfirmarManutencao.vue?vue&type=script&lang=js&"
export * from "./ModalConfirmarManutencao.vue?vue&type=script&lang=js&"
import style0 from "./ModalConfirmarManutencao.vue?vue&type=style&index=0&id=3b203331&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b203331",
  null
  
)

export default component.exports